import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import MultiSelectField from "../Shared/MultiSelectField.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";
import ProductTreeSelector from "./ProductTreeSelector.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'


const AddItemPopup = ({ globalContext }) => {

    const urlParams = new URLSearchParams(window.location.search);

    const defaultProductId = urlParams.get("filter[ProductId]") ?? null;

    const [selectedOption, setSelectedOption] = useState("single-registration");

    const [addProductIds, setAddProductIds] = useState(defaultProductId);
    const [addTitle, setAddTitle] = useState(null);
    const [addDescription, setAddDescription] = useState({ Description: "" });
    const [addChangeAssessmentType, setAddChangeAssessmentType] = useState(null);
    const [addDueDate, setAddDueDate] = useState(null);
    const [addResponsibleOwner, setAddResponsibleOwner] = useState(null);

    const [errorAddTitle, setErrorAddTitle] = useState(false);
    const [errorAddDescription, setErrorAddDescription] = useState(false);
    const [errorAddChangeAssessmentType, setErrorAddChangeAssessmentType] = useState(false);
    const [errorAddResponsibleOwner, setErrorAddResponsibleOwner] = useState(false);
    const [errorAddDueDate, setErrorAddDueDate] = useState(false);
    const [errorAddProductIds, setErrorAddProductIds] = useState(false);
    const [errorAddingItem, setErrorAddingItem] = useState(null);

    const [isAddingItem, setIsAddingItem] = useState(false);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);

    const dropdownRefs = useRef({});

    const AppContext = globalContext;

    const validFormField = (field, errorFunc) => {
        if (
            field === "" ||
            field === null ||
            field === undefined ||
            (Array.isArray(field) && field.length === 0) 
        ) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    const addItem = () => {

        let isValidForm = true;
        let missingFields = [];

        setErrorAddTitle(false);
        setErrorAddDescription(false);
        setErrorAddChangeAssessmentType(false);
        setErrorAddDueDate(false);
        setErrorAddingItem(null);
        setErrorAddProductIds(false);

        if (!validFormField(addTitle, setErrorAddTitle)) {
            isValidForm = false;
            missingFields.push("Title");
        }
        if (!validFormField(addChangeAssessmentType, setErrorAddChangeAssessmentType)) {
            isValidForm = false;
            missingFields.push("Type");
        }
        if (!validFormField(addDueDate, setErrorAddDueDate)) {
            isValidForm = false;
            missingFields.push("Due Date");
        }

        if (!validFormField(addProductIds, setErrorAddProductIds)) {
            isValidForm = false;
            missingFields.push("Product");
        }

        if (!isValidForm) {
            setErrorAddingItem(`Error: ${missingFields.join(", ")} can't be empty`);
            return false;
        }

        let newItem = {
            ProductIds: addProductIds,
            Title: addTitle,
            Description: addDescription.Description,
            ChangeAssessmentType: addChangeAssessmentType ? parseInt(addChangeAssessmentType) : null,
            DueDate: addDueDate,
            ResponsibleOwner: addResponsibleOwner ? parseInt(addResponsibleOwner) : null,
            CustomFieldsAnswers: AppContext.newItemCustomFieldsAnswers,
        };

        
        setIsAddingItem(true);

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };

        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {
                    let message = await response.text();

                    // Safely parse JSON errors to prevent React crashes / infinite spinners
                    try {
                        let jsonErr = JSON.parse(message);
                        if (jsonErr.errors) {
                            message = Object.values(jsonErr.errors).flat().join(", ");
                        } else if (jsonErr.Message || jsonErr.message) {
                            message = jsonErr.Message || jsonErr.message;
                        } else if (jsonErr.title) {
                            message = jsonErr.title;
                        }
                    } catch (e) {
                        // Not JSON, keep raw text
                    }

                    throw new Error(message || "Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {
                let result = [item, ...AppContext.data];
                AppContext.setData(result);
                if (AppContext.updateListTotalCount) AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);
            })
            .catch((error) => {
                console.log("error: " + error);
                setErrorAddingItem(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });
    }

    useEffect(() => {

    }, []);

    // Replaced incorrect types with correct Change Assessment Types
    const changeAssessmentList = [
        { Id: "", Name: "Choose an option" },
        { Id: "0", Name: "Product" },
        { Id: "1", Name: "QMS" },
        { Id: "2", Name: "Legal Manufacturer" },
        { Id: "3", Name: "Manufacturing" }
    ];

    const yesNoList = [
        { Id: "", Name: "Choose an option" },
        { Id: "true", Name: "Yes" },
        { Id: "false", Name: "No" },
    ];

    const renewalPriorityList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },
    ];

    let localContext = {
        currentItem: addDescription,
        setCurrentItem: setAddDescription,
        entityType: "change-assessments",
    };

    return (
        <div className="add-task-popup" style={{ maxWidth: "100%", width: "70%" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}s</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: "15px",
                    marginTop: "10px"
                }}>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "single-registration"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("single-registration")}
                >
                    <i className="fas fa-clipboard-check g-mr-5"></i> Add Change Assessment
                </div>

                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
            </div>

            <div style={{ marginTop: "20px" }}>

                {selectedOption == "single-registration" ?
                    <div style={{ paddingTop: "10px", }}>

                        <div style={{ display: "flex", flexDirection: "row" }}>

                            <div style={{ flex: 1 }}>

                                <div style={{ width: "100%" }}>
                                    Title *
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddTitle ? " form-field-error" : ""}`}
                                        value={addTitle || ""}
                                        onChange={(e) => setAddTitle(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddTitle && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Description
                                    <br />
                                    <FieldTypes.ItemDetailsField_Text AppContext={localContext} field={"Description"} fieldTitle={"Description"} isTextarea={true} mandatory={false} forceIsEditing={true} displayFieldOnly={true} />

                                    {errorAddDescription && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Type *
                                    <br />
                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddChangeAssessmentType ? "form-field-error" : ""}`}
                                        value={addChangeAssessmentType || ""}
                                        onChange={(e) => setAddChangeAssessmentType(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        {changeAssessmentList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddChangeAssessmentType && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Responsible Owner { }
                                    <br />
                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddResponsibleOwner ? "form-field-error" : ""}`}
                                        value={addResponsibleOwner || ""}
                                        onChange={(e) => setAddResponsibleOwner(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">Select User</option>
                                        {AppContext.users.map((user) => (
                                            <option key={user.Id} value={user.Id}>
                                                {user.Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Due Date *
                                    <br />
                                    <input
                                        className={`form-field-text add-task-field-name ${errorAddDueDate ? "form-field-error" : ""}`}
                                        value={addDueDate || ""}
                                        onChange={(e) => setAddDueDate(e.target.value)}
                                        style={{ width: "100%" }}
                                        type="date"
                                    />

                                    {errorAddDueDate && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                {/* CUSTOM FIELDS */}
                                {
                                    <AddItemCustomFields entityType={AppContext.entityTypeId} context={AppContext} />
                                }
                                <br />
                            </div>

                            {/* TREE */}
                            <div style={{ flex: 1, marginLeft: "100px" }}>
                                <ProductTreeSelector onSelectionChange={setAddProductIds} />
                            </div>

                        </div>

                        {/* BUTTONS */}
                        <div className="action-button-bar">
                            <div className="action-button-bar-left">
                                <button
                                    className="action-button cancel-button"
                                    onClick={() => AppContext.showAddItemPopup(false)}
                                >
                                    Close
                                </button>
                            </div>

                            <div className="action-button-bar-center">
                                {errorAddingItem ? <div style={{ color: "#ff5400" }}>{errorAddingItem}</div> : null}
                            </div>

                            <div className="action-button-bar-right">
                                {isAddingItem ? (
                                    <LoadingSpinnerImage />
                                ) : (
                                    <button
                                        className="action-button save-button"
                                        onClick={addItem}
                                    >
                                        Add Change Assessment
                                    </button>
                                )}
                            </div>
                        </div>

                    </div>
                    : null}
            </div>
        </div>
    );
};

// ... Remaining helper components (SearchableCountrySelect, BulkImportProducts, BulkImportUDIs) remain exactly the same.
// Just append them as they were.

const SearchableCountrySelect = ({ label, value, onChange, countries }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const selected = countries.find(c => c.id == value);

    const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={{ width: "100%", position: "relative" }}>
            {label}
            <br />
            <input
                type="text"
                value={isOpen ? search : (selected?.name || "")}
                placeholder="Search country..."
                onFocus={() => { setIsOpen(true); setSearch(""); }}
                onChange={(e) => { setSearch(e.target.value); setIsOpen(true); }}
                onBlur={() => { setTimeout(() => setIsOpen(false), 150); }}
                style={{ width: "100%", padding: "6px", border: "1px solid #ccc", borderRadius: "4px" }}
            />
            {isOpen && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "200px", overflowY: "auto", background: "#fff", border: "1px solid #ccc", borderRadius: "4px", zIndex: 1000 }}>
                    {filtered.length > 0 ? (
                        filtered.map(country => (
                            <div key={country.id} onMouseDown={(e) => e.preventDefault()}
                                onClick={() => { onChange(country.id); setIsOpen(false); setSearch(country.name); }}
                                style={{ padding: "6px", cursor: "pointer" }}>
                                {country.name}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px", color: "#888" }}>No results</div>
                    )}
                </div>
            )}
        </div>
    );
};


export default AddItemPopup;